import React, { PropsWithChildren, useEffect, useState } from "react";
import { VersionContext } from "~/versionControl/context";
import { GetVersionConfig } from "~/client/http/GetVersionConfig";
import configAggregationLocale, {
  versionConfigAggregation,
} from "~/versionControl/configAggregation";
import Preloader from "~/components/Preloader";

const VersionContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    fallBackVersionControl: {
      ...configAggregationLocale,
    },
  });

  useEffect(() => {
    setLoading(true);
    GetVersionConfig()
      .then((actualVersionConfig) => {
        if (Array.isArray(actualVersionConfig)) {
          setState((p) => ({
            ...p,
            actualVersionControl: versionConfigAggregation(actualVersionConfig),
          }));
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const loadingWrapper = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <VersionContext.Provider value={{ state, setState }}>
      {loading ? (
        <div style={loadingWrapper}>
          <Preloader />
        </div>
      ) : (
        children
      )}
    </VersionContext.Provider>
  );
};

export default VersionContextProvider;

const LoaderWrapper = () => {
  GetVersionConfig().then(console.log);
};
